module.exports = __webpack_public_path__ + "img/sport-3.7abed54e.jpg";